import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChecklistStorageService {
  private readonly STORAGE_PREFIX = 'skidChecklist';

  constructor() { }

  private getStorageKey(projectId: number, blockScheduleId: number, templateId: number): string {
    return `${this.STORAGE_PREFIX}_${projectId}_${blockScheduleId}_${templateId}`;
  }

  saveTemplateData(
    projectId: number,
    blockScheduleId: number,
    templateId: number,
    data: { [lineItemId: number]: any }
  ): void {
    try {
      const key = this.getStorageKey(projectId, blockScheduleId, templateId);
      const storageData = {
        data: data,
        timestamp: new Date().toISOString(),
        projectId: projectId,
        blockScheduleId: blockScheduleId,
        templateId: templateId
      };
      localStorage.setItem(key, JSON.stringify(storageData));
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }
  }

  loadTemplateData(
    projectId: number,
    blockScheduleId: number,
    templateId: number
  ): { data: { [lineItemId: number]: any }, timestamp: string } | null {
    try {
      const key = this.getStorageKey(projectId, blockScheduleId, templateId);
      const stored = localStorage.getItem(key);

      if (!stored) {
        return null;
      }

      const parsed = JSON.parse(stored);
      return {
        data: parsed.data,
        timestamp: parsed.timestamp
      };
    } catch (error) {
      console.error('Error loading from localStorage:', error);
      return null;
    }
  }

  clearTemplateData(projectId: number, blockScheduleId: number, templateId: number): void {
    try {
      const key = this.getStorageKey(projectId, blockScheduleId, templateId);
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  }

  clearAllTemplateData(projectId: number, blockScheduleId: number): void {
    try {
      const keys = Object.keys(localStorage);
      const prefix = `${this.STORAGE_PREFIX}_${projectId}_${blockScheduleId}`;

      keys.forEach(key => {
        if (key.startsWith(prefix)) {
          localStorage.removeItem(key);
        }
      });
    } catch (error) {
      console.error('Error clearing all localStorage:', error);
    }
  }

  hasTemplateData(projectId: number, blockScheduleId: number, templateId: number): boolean {
    const key = this.getStorageKey(projectId, blockScheduleId, templateId);
    return localStorage.getItem(key) !== null;
  }
}
